export default function ({
  appScroll,
  utilZoom,
  mainMenu,
  homeIntro,
  elastic,
  dynamicVue,
  map,
  drag,
  news
}) {
  $('.main-menu .main-nav a').click(function (e) {
    e.preventDefault();
    loadPage(this.href);
    $('.main-menu').removeClass('show');
  });

  var dynLinks = function () {
    $('.prod-list-item a.lg-btn, .prod-list-item a.fullsc-link').click(
      function (e) {
        e.preventDefault();
        loadPage(this.href, false, {
          transition: 'product',
          el: $(this).closest('section'),
        });
      }
    );
    $('.team-list a.fullsc-link').click(function (e) {
      e.preventDefault();
      loadPage(this.href, false, {
        transition: 'product2',
        el: $(this).closest('li'),
      });
    });
    $(
      '.nav-bar a, aside.nav .logo a, .intro-carousel-scale a.lg-btn, .page-list-item a.more-link, .intro-carousel-scale a.fullsc-link, .abouts-content .more-link, .methods-text .more-link, .news-list .full-link, .hiring-content .lg-btn, .page-items-list .more-link, .newscat-list .full-link, .newslist-list a, .footer-content p a, .newscat-list ul li a.full-link'
    ).click(function (e) {
      e.preventDefault();
      if (
        $(this).closest('.logo').length ||
        (!$(this).closest('.prod-list-item').length &&
          !$(this).hasClass('current'))
      )
        loadPage(this.href);
    });
  };
  dynLinks();

  var loadPage = function (href, skipHistory, args) {
    args = args || {};
    args.transition = args.transition || 'default';

    var transitionLength = 100;
    $('.loader').remove();
    var l = $('<div />', { class: 'loader' });
    if (args.transition == 'default') {
      $('.main-menu').before(l);
      setTimeout(() => l.addClass('mid'), 50);
    }
    if (args.transition == 'product') {
      transitionLength = 200;
      args.el.addClass('fsi2');
      appScrollbar.scrollTo(
        0,
        appScrollbar.offset.y + args.el.offset().top,
        500
      );
    }
    if (args.transition == 'product2') {
      transitionLength = 200;

      appScrollbar.scrollTo(0, 0, 500);
      var index = $('.team-list li').index(args.el);
      $('.prod-list-item')
        .eq(index)
        .find('.start-anim, .to-anim')
        .removeClass('start-anim to-anim anim-zoomout');
      $('.prod-list-item').eq(index).show().addClass('fsi-extra');
      setTimeout(() => {
        $('.prod-list-item').eq(index).addClass('fsi2');
      }, 30);
    }

    var doFinishLoading = () => l.removeClass('mid').addClass('end');
    var loading1 = false;
    var finishLoading = () =>
      loading1 ? doFinishLoading() : (loading1 = true);
    setTimeout(finishLoading, 400);
    var now = new Date().getTime();
    $.get(
      href,
      function (data) {
        var $data = $(data);
        var now2 = new Date().getTime();
        setTimeout(() => {
          document.title = $data.filter('title').html().trim();
          appScrollbar.destroy();
          $('.scroll-container').html($data.filter('.scroll-container').html());
          $('.sec-nav').remove();
          if ($data.filter('.sec-nav').length) {
            var secNav = $('<section />', {
              class: 'sec-nav',
              'data-anim': 'secnav',
            });
            $('.scroll-container').before(secNav);
            secNav.html($data.filter('.sec-nav').html());
          }
          appScroll({ immediate: true, transition: args.transition });
          if (args.transition == 'product') {
            $('.proj-bg .anim-imgzoom').removeClass('to-anim');
            $('.sec-nav').removeClass('start-anim').addClass('to-anim');
          }
          if (args.transition == 'product2') {
            $('.proj-bg .anim-imgzoom').removeClass('to-anim');
            $('.sec-nav').removeClass('start-anim').addClass('to-anim');
          }
          utilZoom();
          homeIntro({ immediate: true });
          mainMenu();
          elastic();
          dynamicVue();
          map();
          finishLoading();
          dynLinks();
          drag();
          news();
        }, Math.max(1, transitionLength - (now2 - now)));
      },
      'text'
    );
    if (!skipHistory) history.pushState({}, '', href);
  };
  window.addEventListener('popstate', function () {
    loadPage(document.location, true);
  });
}
